import React from "react";
import { DebugBorders } from "../App";
import { Box, SxProps } from "@mui/material";

// TYPES

type Props = {
  children: React.ReactNode;
  sx?: SxProps;
};

export function SurveyBody({ children, sx = {} }: Props) {
  // STATE

  const debugBorders = React.useContext(DebugBorders);

  // RENDER

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        rowGap: 3,
        border: debugBorders ? "1px solid green" : "",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
